import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const Pin = ({
  width = 26,
  height = 26,
  stroke = colors.darkBlue,
  responsive = false,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 26"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <circle
        opacity=".5"
        cx="13"
        cy="13"
        r="12.5"
        stroke={stroke}
        />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={stroke}
        d="M10.172 9.15A4.037 4.037 0 0 1 13 8c1.06 0 2.078.414 2.828 1.15A3.894 3.894 0 0 1 17 11.93c0 2.992-3.618 5.872-3.774 5.993a.368.368 0 0 1-.452 0 3.348 3.348 0 0 0-.039-.033C12.315 17.542 9 14.788 9 11.93c0-1.043.421-2.042 1.172-2.78ZM13 13.557c.947 0 1.714-.746 1.714-1.666 0-.921-.767-1.667-1.714-1.667s-1.714.746-1.714 1.666c0 .921.767 1.668 1.714 1.668Z"
        />
    </svg>
  )
}

export default Pin
